(function ($) {
    'use strict';

    var recaptcha, validateForm;
    
    var submittingForm = false;

    $(window).ready(function () {
        recaptcha = Fw.component.models().utils.recaptcha;
        validateForm = Fw.component.models().form.validateForm;

        $('.candidate-cv-btn').on('click', openCV);
        
        $('.job-candidate-application-form .confirm-btn').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendApplication.call(btn, response, form);
            }, true, $(this).closest('.job-candidate-application-form'));
        });

        $('.candidate-contact-form button').each(function () {
            recaptcha(this, function (response, form, btn) {
                sendContact.call(btn, response, form);
            }, true, $(this).closest('.candidate-contact-form'));
        });

    });

    function openCV(e) {
        e.preventDefault();
        var btn = $(this);
        var link = btn.attr('data-link');
        var candidateId = btn.attr('data-id');

        if (btn.hasClass("notify-view")) {
            $.post('/action/candidateSendEmail?notify=true&id=' + candidateId, function () {
                btn.removeClass("notify-view");
            });
        }

        window.open(link, '_blank');
    }
    
    function sendApplication(captchaToken ,form) {
        form.find('input[name="captcha"]').val(captchaToken);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            form.submit();
        }
    }

    function sendContact(captchaToken, form) {
        var captchaInput = form.find('input[name="captcha"]');
        
        $('.candidate-contact-sent-message').removeClass('show');
        captchaInput.val(captchaToken);
        validateForm(form);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            $.post('/action/candidateSendEmail',
                    form.serialize(),
                    function () {
                        submittingForm = false;
                        $('.candidate-contact-sent-message').addClass('show');
                        form.closest('.popup-outer.open').removeClass('open');
                        form[0].reset();
                        captchaInput.val('');
                    }
            );
        }
    }

})(jQuery);
